module.exports = __webpack_public_path__ + "img/login-copaatahualpa.0080e455.svg";